// extracted by mini-css-extract-plugin
module.exports = {"table":"DashboardReportTable_table__L9Z2D"};